import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../Firebase";

export default function ProtectedRoute({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsub = onAuthStateChanged(
      auth,
      (currentUser) => {
        setUser(currentUser || null);
      },
      (error) => {
        console.error("Auth state error:", error);
        setUser(null);
      }
    );

    return () => unsub();
  }, []);

  // Still checking auth
  if (user === undefined) {
    return (
      <div style={{ padding: "3rem", textAlign: "center" }}>
        <h1 style={{ marginBottom: "0.5rem" }}>Checking access…</h1>
        <p style={{ color: "#555" }}>
          Verifying your admin session.
        </p>
      </div>
    );
  }

  // Not logged in
  if (!user) return <Navigate to="/admin/login" replace />;

  // Logged in
  return children;
}
